export default function useInputUpdate(dispatch) {
   return (e) => {
      const { name, value } = e.target;
      dispatch({
         type: "updateInput",
         payload: { name, value },
      });
   };
}
